import { Box, Text, useClassNames } from '@factorialco/deprecated-design-system'

import * as stylesRefs from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'

import HoverInfoCard from '../../../../../../HoverInfoCard'
import { ScheduleRecordValuesType } from '../../../types'
import { cellText, gridColumnSpan } from '../../../utils'
import SubRowCellHoverContent from './SubRowCellHoverContent'

interface ISubRowCellProps {
  span: number
  record?: ScheduleRecordValuesType
  openSidepanel: (data?: ScheduleRecordValuesType | null) => void
}

const SubRowCell = ({ span = 1, record, openSidepanel }: ISubRowCellProps) => {
  const cx = useClassNames(stylesRefs)

  return (
    <Box padding="s8" className={cx('scheduleItemCell')} style={{ ...gridColumnSpan(span) }}>
      {record?.dailyMinutes && (
        <HoverInfoCard
          title={record?.group}
          subtitle={record?.title}
          description={record?.subtitle}
          content={<SubRowCellHoverContent record={record} />}
        >
          <Box
            border={{ all: { color: 'purple1000', width: 's1', style: 'solid' } }}
            borderRadius={{ all: 'abs008' }}
            background="white"
            paddingY="s6"
            paddingX="s8"
            cursor="pointer"
            flexDirection="row"
            onClick={() => openSidepanel(record)}
          >
            <Text.Normal size="100" color="grey800" ellipsis>
              {cellText(record?.dailyMinutes || 0, record?.title)}
            </Text.Normal>
          </Box>
        </HoverInfoCard>
      )}
    </Box>
  )
}

export default SubRowCell
